/**
 * Brevo capture handler
 * Intercepts all blog CRO form submissions, POSTs directly to Brevo Contacts API v3,
 * and fires GA4 events + sets cookies for frequency capping.
 *
 * API key injected via window.__BREVO_API_KEY from theme settings.
 */
(function() {
  var forms = document.querySelectorAll('form[data-source]');
  if (!forms.length) return;

  var SOURCE_TO_LIST = {
    'blog-exit-intent': 104,
    'blog-sidebar': 105,
    'blog-scroll-banner': 106
  };

  forms.forEach(function(form) {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      var formData = new FormData(form);
      var source = form.getAttribute('data-source');
      var listId = SOURCE_TO_LIST[source] || 105;
      var email = formData.get('email');
      var sms = formData.get('sms');

      var btn = form.querySelector('button[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }

      var payload = {
        email: email,
        listIds: [listId],
        updateEnabled: true,
        attributes: {
          SOURCE: source,
          BLOG_POST: formData.get('post_slug') || '',
          BLOG_THEME: formData.get('post_theme') || ''
        }
      };

      if (sms && sms.trim()) {
        payload.attributes.SMS = sms.trim();
      }

      var upgradeId = formData.get('content_upgrade_id');
      if (upgradeId) {
        payload.attributes.CONTENT_UPGRADE_ID = upgradeId;
      }

      try {
        var response = await fetch('https://api.brevo.com/v3/contacts', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'api-key': window.__BREVO_API_KEY || ''
          },
          body: JSON.stringify(payload)
        });

        if (response.status === 400) {
          var body = await response.json().catch(function() { return {}; });
          var errDiv = form.querySelector('.blog-form-error') || document.createElement('div');
          errDiv.className = 'blog-form-error';
          errDiv.textContent = body.message || 'Please check your email address.';
          errDiv.style.cssText = 'color:#D90073;font-size:13px;margin-top:8px;';
          form.appendChild(errDiv);
          if (btn) { btn.disabled = false; btn.textContent = originalText; }
          return;
        }

        if (response.status !== 201 && response.status !== 204) {
          throw new Error('Capture failed: ' + response.status);
        }

        // GA4 events
        if (window.gtag) {
          gtag('event', 'email_capture', {
            source: source,
            post_theme: formData.get('post_theme') || '',
            post_slug: formData.get('post_slug') || ''
          });
          if (sms && sms.trim()) {
            gtag('event', 'sms_capture', {
              source: source,
              post_theme: formData.get('post_theme') || '',
              post_slug: formData.get('post_slug') || ''
            });
          }
          if (upgradeId) {
            gtag('event', 'content_upgrade_request', {
              source: source,
              upgrade_id: upgradeId,
              post_slug: formData.get('post_slug') || ''
            });
          }
        }

        // Mark session engaged (frequency cap)
        try { sessionStorage.setItem('viori_cta_engaged_session', 'true'); } catch(ex) {}

        // Subscriber cookie suppresses future exit-intent (90 days)
        document.cookie = 'viori_subscriber=1;max-age=7776000;path=/;SameSite=Lax';

        // Success UI
        form.innerHTML = '<div class="blog-form-success"><strong>Check your inbox.</strong> Your guide is on its way.</div>';

      } catch(err) {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
        var errDiv = form.querySelector('.blog-form-error') || document.createElement('div');
        errDiv.className = 'blog-form-error';
        errDiv.textContent = 'Something went wrong. Please try again.';
        errDiv.style.cssText = 'color:#D90073;font-size:13px;margin-top:8px;';
        form.appendChild(errDiv);
      }
    });
  });
})();
